export function getSubAppContainer() {
  const subAppContainer = document.getElementById('subapp_container');

  if (subAppContainer == null) {
    throw new Error("Sub app container '#subapp_container' not found!");
  }

  return subAppContainer;
}
